/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import _ from 'lodash';
import React from 'react';
import { decorate, observable, runInAction } from 'mobx';
import { observer, inject } from 'mobx-react';
import Input from '@amzn/base-ui/dist/parts/helpers/fields/Input';
import SelectionButtons from '@amzn/base-ui/dist/parts/helpers/fields/SelectionButtons';

class ExtraEnvParams extends React.Component {
  constructor() {
    super();

    runInAction(() => {
      this.repoFieldKeywords = ['testbed', 'ads', 'solution'];
      this.exposeOptions = [
        { text: 'Enabled', value: true },
        { text: 'Disabled', value: false },
      ];
    });
  }

  render() {
    let adsEntries = []

    const titleLower = this.props.title.toLowerCase();
    if (this.repoFieldKeywords.some(keyword => titleLower.includes(keyword))) {
      adsEntries = this.renderADSEntries();
    }

    return [
      ...adsEntries,
      <SelectionButtons
        field={this.props.form.$('crossCommunication')}
        options={this.exposeOptions}
        alt="true"
        className="elem"
        onChange={this.handleExposeOptionOnChange}
        disabled={this.props.lockCrossCommunication}
      />
    ];
  }

  handleExposeOptionOnChange = (__, { value }) => {
    this.props.form.$('crossCommunication').set(value);
  };

  renderADSEntries() {
    return [
      <Input
        key="ids-testbed-repo"
        data-test-id="ids-testbed-repo"
        field={this.props.form.$('IDSTestbedRepo')}
        name="Testbed URL"
        className="elem"
        showErrorLabel={false}
      />
    ];
  }
}

decorate(ExtraEnvParams, {
  repoFieldKeywords: observable,
  exposeOptions: observable,
});

export default inject()(observer(ExtraEnvParams));
